import * as angular from 'angular';

"use strict";

angular.module('ModuleModule', [])

export default 'ModuleModule';